import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { StandardCost } from 'src/app/models';

@Component({
    selector: 'app-products-costs-add',
    templateUrl: './products-costs-add.component.html',
    styleUrl: './products-costs-add.component.sass',
    standalone: false
})
export class ProductsCostsAddComponent extends GenericCrudAddComponent<StandardCost> {
  override initFormGroup(): FormGroup<any> {
    const group = this.fb.group({
      date: [undefined],
      cost: [undefined]
    });
    
    return group;
  }

}
